export default function AppToggle({
  checked = false,
  onChange,
  disabled = false,
  ariaLabel = 'Toggle',
  className = '',
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => {
        if (disabled) return
        onChange?.(!checked)
      }}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full p-[2px] transition-colors ${
        checked ? 'bg-primary' : 'bg-surface-container-highest'
      } ${disabled ? 'cursor-not-allowed opacity-60' : ''} ${className}`}
    >
      <span
        className={`h-5 w-5 rounded-full bg-white shadow-sm transition-transform ${
          checked ? 'translate-x-5' : 'translate-x-0'
        }`}
      />
    </button>
  )
}
